import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class PermissionsRoute extends Route {
  @service session;

  async beforeModel(transition) {
    if (!this.session.requireAuthentication(transition, 'login')) {
      return;
    }

    if (!this.session.isAdministrator) {
      this.router.transitionTo('index');
    }
  }
}
